import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { CheckSensitiveWordDTO } from '../service/ai-translation.repository.interface';
import { CheckSensitiveWord } from '@/infrastructure/api-functions/interface/check-sensitive-word.interface';

@injectable()
export class CheckSensitiveWordDTOImpl implements CheckSensitiveWordDTO {
    constructor(
        @inject(CheckSensitiveWord)
        private readonly _checkSensitiveWordApi: CheckSensitiveWord,
    ) { }

    async fetch(value: string): Promise<string> {
        const res = await this._checkSensitiveWordApi.checkSensitiveWord({ tech_desc: value });

        return res.out;
    }
}
